import { useState } from 'react';
import SubscriptionClient from 'src/services/SubscriptionClient';

const usePendingChanges = (
  authProvider: any,
  stack: number,
  subscriptionId: string
) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isPlanChangeDone, setIsPlanChangeDone] = useState<boolean>(false);

  const subscriptionsClient = new SubscriptionClient(authProvider, stack);

  const fetchPendingChanges = async () => {
    setLoading(true);
    try {
      const response =
        await subscriptionsClient.getPendingChanges(subscriptionId);
      setData(response);
      setIsPlanChangeDone(
        response?.contents?.some(
          (entity: any) =>
            entity?.type === 'planChange' &&
            entity?.reason?.type === 'customerRequestedPlanChange'
        )
      );
      setLoading(false);
    } catch (error) {
      setError(true);
      setLoading(false);
      console.error('Error fetching pending changes:', error);
    }
  };

  return {
    data,
    loading,
    error,
    isPlanChangeDone,
    fetchPendingChanges
  };
};

export default usePendingChanges;
